import React from 'react';
import ProductItemTitles from '../Shared/ProductItemTitles';
import {ColumnHtml, ColumnTwoPartsHtml, ColumnHtmlWithIcon} from '../Shared/sharedHtmlComponents';
import {isMobile} from 'react-device-detect';
import {productStatus} from '../productsAndServicesBlockSlice';
import ProductStatus from '../Shared/ProductStatus';
import CategoryName from '../Shared/CategoryName';
import {productsTypes} from '../productsAndServicesBlockSlice';
const TVItem = (props) => {
  const itemTitles = ['מוצר', 'כתובת התקנה', 'חבילה', 'ממירים'];
  const widthList = ['20', '30', '25', '25'];
  //  const itemTitles = ['מוצר', 'כתובת התקנה', 'חבילה', 'חבילת פרימיום', 'ממירים'];
  // const widthList = ['20', '25', '20', '20', '15'];
  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName
        title={`${window.Config.brand_Name_HE} TV`}
        imageName={`${isMobile ? 'tv' : 'tv-desc'}`}
        goToAction={props.goToAction}
        goToAllAction={props.goToAllAction}
        actions={props.tvActions}
        allActionButtonText={props.allActionButtonText}
        type={productsTypes.TV}
      />
      {!isMobile && <ProductItemTitles titlesList={itemTitles} widthList={widthList} />}
      {props.tvItems?.map((tvItem, index) => {
        const subscriberNo = tvItem.subscriberNumber;
        const ban = tvItem.ban;
        const tvType = tvItem.tvType == 'CellcomTV' ? `${window.Config.brand_Name_HE} TV` : `אפליקציה ${window.Config.brand_Name_HE} TV`;
        const equipment = tvItem.tvType != 'CellcomTV' ? `אפליקציה` : `${tvItem.equipmentCount} ממירים`;
        const status =
          tvItem.productStatus == productStatus.BUSINESS ||
          tvItem.productStatus == productStatus.CANCELLED ||
          tvItem.productStatus == productStatus.SUSPENDED
            ? tvItem.productStatus
            : null;
        return (
          <div key={index}>
            {!isMobile ? (
              <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                {status && <ProductStatus status={status} />}
                <ColumnHtml item={tvType} columnWidth={widthList[0]} customClass={'semiBold'} />
                <ColumnHtml item={tvItem.customerAddress} columnWidth={widthList[1]} />
                <ColumnHtmlWithIcon
                  item={tvItem.packageName}
                  columnWidth={widthList[2]}
                  buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                />
                {/* <ColumnHtml item={tvItem.premiumPackagesCount} columnWidth={widthList[3]} /> */}
                <ColumnHtml item={equipment} columnWidth={widthList[3]} />
              </div>
            ) : (
              <div className='productAndServicesItemContainer_content_wrapper'>
                <ColumnTwoPartsHtml title={tvType} titleCustomClass={'semiBold black'} textCustomClass={'status'}>
                  {status && <ProductStatus status={status} />}
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={'חבילה'}>
                  <ColumnHtmlWithIcon item={tvItem.packageName} buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})} />
                </ColumnTwoPartsHtml>
                {/* <ColumnTwoPartsHtml title={'חבילות פרימיום'} text={`${tvItem.premiumPackagesCount} חבילות `} /> */}
                <ColumnTwoPartsHtml title={'כתובת התקנה'} text={tvItem.customerAddress} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default TVItem;
